'use strict';

var Classnames = require('classnames');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');
var SmoothScroll = require('smoothscroll');
// var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

var Constants = require('../../constants');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./faq.scss');
}

var QandA = React.createClass({
    reveal: function() {
        if (this.props.openId.value != this.props.q.id) {
            // Store viewport position of about-to-be-revealed answer
            this.props.top.requestChange(this.refs.answer.getBoundingClientRect().top);

            // Open this answer
            this.props.openId.requestChange(this.props.q.id);
        } else {
            this.props.openId.requestChange(null);
        }
        this.props.scrollTarget.requestChange(null);
    },
    componentDidUpdate: function(prevProps, prevState) {
        // The previous answer disappearing moves the viewport's scroll position, so keep the tapped question static on the page
        if (prevProps.openId.value != this.props.q.id && this.props.openId.value == this.props.q.id) {
            window.scrollTo(0, this.refs.answer.offsetTop - this.props.top.value);

            // If new answer ends off bottom of page, scroll it into view
            var bottom = this.refs.answer.getBoundingClientRect().bottom;
            if (bottom > window.innerHeight) {
                // this.props.scrollTarget(bottom - window.innerHeight + 20);
                SmoothScroll(window.scrollY + (bottom - window.innerHeight + 32));
            }
        }
    },
    render: function() {
        var q = this.props.q;
        var active = this.props.openId.value == q.id;
        var classes = Classnames({
            'pg-faq-q': true,
            'pg-faq-q-active': active,
        });
        var reveal = active ? 'minus-grey1' : 'plus-grey1';
        return (
            <div className='pg-faq-qanda'>
                <div className='pg-faq-reveal'>
                    <img src={`${Constants.static}images/global/expansion/${reveal}.png`} />
                </div>

                <div className='pg-faq-reveal-block' ref='answer'>
                    <button className={classes} onClick={this.reveal}>
                        {q.question}
                    </button>

                    {active ?
                        <div className='pg-faq-a' dangerouslySetInnerHTML={{ __html: q.answer }} />
                    : null}
                </div>
            </div>
        );
    }
});

var Topic = React.createClass({
    render: function() {
        var questions = this.props.topic.questions.map(q => {
            return <QandA q            = {q}
                          key          = {q.id}
                          openId       = {this.props.openId}
                          top          = {this.props.top}
                          scrollTarget = {this.props.scrollTarget} />
        });
        return (
            <div className='pg-faq-topic'>
                <h2>
                    {this.props.topic.title.toUpperCase()}
                </h2>
                {questions}
            </div>
        );
    }
});

var FAQ = React.createClass({
    mixins: [ LinkedStateMixin ],

    getInitialState: function() {
        return {
            // topic.id of currently open question
            openId: null,

            // getBoundingClientRect().top of open question - captured on tap and restored after DOM updates
            // (as closing previously open answer will move the page scroll position)
            top: null,

            scrollTarget: null,
        };
    },
    componentDidUpdate: function() {
        // if (this.state.scrollTarget != null) {
            // window.scrollBy(0, window.scrollY > );
        // }
    },
    render: function() {
        if (!this.props.payload.extra || !this.props.payload.extra.faq)
            return <div />;

        var topics = this.props.payload.extra.faq.map(topic => {
            return (
                <Topic topic        = {topic}
                       key          = {topic.id}
                       openId       = {this.linkState('openId')}
                       top          = {this.linkState('top')}
                       scrollTarget = {this.linkState('scrollTarget')} />
            );
        });
        return (
            <div className='pg-content pg-content-sidebar pg-faq'>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <br />
                {topics}
            </div>
        );
    }
});


module.exports = FAQ;



// WEBPACK FOOTER //
// ./src/pages/content/faq.jsx